<div class="sub-header">
  <div class="sub-header-content">
    <span>{{ pageTitle }}</span>
    <!--<div class="button-group">
      <dx-button icon="refresh" type="default" (click)="refreshPage()"></dx-button>
      <dx-button (click)="navigateToHome()" icon="home" type="default"></dx-button>
    </div>-->
  </div>
</div>
